import { authenticatedRequest } from './api';

const API_BASE = '/admin/categories';

export const categoryService = {
  // Get all categories
  async getCategories() {
    try {
      const response = await authenticatedRequest(`${API_BASE}/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch categories'
      };
    }
  },

  // Get category by ID
  async getCategoryById(categoryId) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/${categoryId}/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch category'
      };
    }
  },

  // Get category tree
  async getCategoryTree() {
    try {
      const response = await authenticatedRequest(`${API_BASE}/tree/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch category tree'
      };
    }
  },

  // Get lazy-loaded category tree (top-level only)
  async getCategoryTreeLazy() {
    try {
      const response = await authenticatedRequest(`${API_BASE}/tree-lazy/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch lazy category tree'
      };
    }
  },

  // Get children of a specific category
  async getCategoryChildren(categorySid) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/tree-lazy/${categorySid}/children/`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch category children'
      };
    }
  },

  // Create category
  async createCategory(categoryData) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(categoryData)
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to create category'
      };
    }
  },

  // Update category
  async updateCategory(categoryId, categoryData) {
    try {
      const response = await authenticatedRequest(`${API_BASE}/${categoryId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(categoryData)
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to update category'
      };
    }
  },

  // Delete category
  async deleteCategory(categoryId) {
    try {
      await authenticatedRequest(`${API_BASE}/${categoryId}/`, {
        method: 'DELETE'
      });
      return {
        success: true
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to delete category'
      };
    }
  }
};
